import React, {Component, PropTypes} from "react";
import _ from "lodash";

export default class HistoryValue extends Component {

  constructor(props) {
    super(props);
    this.state = {};
  }

  getValueString(historyUnit_id, historyValue, historyUnit, selectedUnit, conversionTable){
    // If no unit ID or the selected unit is not found in table just return the unconverted value + unit
    if(historyUnit_id === null || _.isUndefined(_.find(conversionTable, { 'unitId': selectedUnit})))
      return historyValue + ' ' + (historyUnit!==null?historyUnit:'');

    // Find conversion number in table for old unit
    const conversionFrom = _.find(conversionTable, { 'unitId': historyUnit_id}).conversion;

    // Convert old value to unit id 1
    const valueOne = historyValue*conversionFrom;

    // Find conversion number in table for new unit
    const conversionTo = _.find(conversionTable, { 'unitId': selectedUnit}).conversion;

    // Convert old value to new unit
    const newValue = valueOne/conversionTo;

    // find new unit
    const newUnit = _.find(conversionTable, { 'unitId': selectedUnit}).unit;

    //console.log(conversionFrom, conversionTo, valueOne, newValue);

    return (Math.round(newValue * 100) / 100)+' '+newUnit;
  }

  render() {
    const {historyUnit_id, historyValue, historyUnit, selectedUnit, conversionTable} = this.props;
    const historyValueString = this.getValueString(historyUnit_id, historyValue, historyUnit, selectedUnit, conversionTable);

    return (
    <div className="history">
      {historyValueString}
    </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/HistoryValue.js